import React from 'react';
import ReactDOM from 'react-dom/client';
import './Bootstrap5.css';
import './index.css';
import App from './App';
import { store } from './reduxAuth/store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

